export class productListViewController {
    product: any;
    onCompareClick: any;
    constructor(private $timeout, private MyConstant) {
        "ngInject"

    }

    addtocompare(product) {
        this.onCompareClick({ product: product });
    }
    $onInit() {
        
    }
}



// WEBPACK FOOTER //
// ./src/components/product-list-view/product-list-view.controller.ts